import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ViewUI from 'view-design';
import moment from 'moment';

/*右边工具栏样式*/
import "babel-polyfill";

// 自定义样式
import './index.less';

Vue.use(ViewUI);

Vue.prototype.$moment = moment;
Vue.prototype.$Message.config({
    duration: 3
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
